export default {
    en: {
        LP: {
            // 言語切り替えボタン
            change_locale: '日本語',

            // OGP用情報
            ogp: {
                title: '',
                description: '',
                type: 'website',
                url: '',
                site_name: '',
                image: '/Images/Ogp/OGP.jpg',
                twitter_card: 'summary_large_image'
            },

            // INTRO
            intro: {
                headering: 'TEXT TEXT TEXT' +
                    '\r\n' +
                    'TEXT TEXT TEXT TEXT',
                lead_sp: 'TEXT TEXT TEXT TEXT TEXT TEXT' +
                    '\r\n' +
                    'TEXT TEXT TEXT TEXT TEXT TEXT',
                lead_pc: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT' +
                    '\r\n' +
                    'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT',
            },

            //新型コロナウイルス感染症対策について
            covid19: {
                title: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT',
                notice: 'TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXTTEXT TEXT TEXT TEXT' +
                    '\r\n' +
                    'TEXT TEXT TEXT TEXT',
                detail: 'Detail',
                spec: 'TEXT TEXT TEXT TEXT ',
                subtitle: 'TEXT TEXT TEXT TEXT ',
                closing: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTTEXT TEXT TEXT TEXT',
            },
            covid19_guide1: [{
                    thumbnail: './Images/covid/corona_pic_01_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },
                {
                    thumbnail: './Images/covid/corona_pic_02_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },

            ],
            covid19_guide2: [{
                    thumbnail: './Images/covid/corona_pic_06_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },
                {
                    thumbnail: './Images/covid/corona_pic_05_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },
                {
                    thumbnail: './Images/covid/corona_pic_03_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },
                {
                    thumbnail: './Images/covid/corona_pic_04_black.svg',
                    description: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
                },
            ],

            // CONTENTS
            contents: {
                summary: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
            },
            contents1: {
                image: './Images/contents/sample-contents.jpg',
                title: 'TEXT TEXT TEXT TEXT TEXT',
                title_sub: 'TEXT TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                more: 'Read more',
                more_text: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                close: 'Close',
            },

            contents2: {
                image: './Images/contents/sample-contents.jpg',
                title: 'TEXT TEXT TEXT TEXT TEXT',
                title_sub: 'TEXT TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                more: 'Read more',
                more_text: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                close: 'Close',
            },

            contents3: {
                image: './Images/contents/sample-contents.jpg',
                title: 'TEXT TEXT TEXT TEXT TEXT',
                title_sub: 'TEXT TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                more: 'Read more',
                more_text: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                close: 'Close',
            },

            contents4: {
                image: './Images/contents/sample-contents.jpg',
                title: 'TEXT TEXT TEXT TEXT TEXT',
                title_sub: 'TEXT TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                more: 'Read more',
                more_text: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                close: 'Close',
            },

            contents5: {
                image: './Images/contents/sample-contents.jpg',
                title: 'TEXT TEXT TEXT TEXT TEXT',
                title_sub: 'TEXT TEXT TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                more: 'Read more',
                more_text: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXTEXT TEXT',
                close: 'Close',
            },

            //APP
            app: {
                ar_image: './Images/app/sample-app.jpg',
                vr_image: './Images/app/sample-app.jpg',
                inc_play: './Images/app/Naked-Inc_Play.jpg',
                google: './Images/app/google-play.png',
                google_link: 'https://play.google.com/store/apps/details?id=jp.co.naked.app02',
                apple: './Images/app/apple-app.png',
                apple_link: 'https://apps.apple.com/jp/app/naked-inc-play/id1534676228',
            },

            //ARTIST
            artist: {
                image: './Images/sample-artist.jpg',
                job: 'TEXT TEXT TEXT',
                name: 'TEXT TEXT TEXT',
                caption: 'TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT TEXT ',
            },

            // TICKETS
            tickets_button: 'Tickets Site',

            // OUTLINE
            outline: {
                name: 'TEXT TEXT',
                term: 'TEXT TEXT',
                time: 'TEXT TEXT',
                place: 'TEXT TEXT TEXT TEXT TEXT TEXT',
            },

            // ACCESS
            access: {
                caption: 'TEXT TEXT TEXT TEXT TEXT' +
                '\r\n' +
                'TEXT TEXT TEXT TEXT TEXT TEXT',
                parking: 'TEXT TEXT',
                parking_button: 'Detail',
                parking_1: 'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT',

                parking_2: 'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT',

                parking_3: 'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT' + '\r\n' +
                    'TEXT TEXT TEXT TEXT',

            },


            //CREDIT
            credit: {
                organizer: 'Organizer',
                support: 'Supporter',
                project: 'Derecting | Writing',
                caption: 'TEXT TEXT TEXT TEXT ' + '\r\n' +
                    'TEXT TEXT TEXT TEXT ' + '\r\n' +
                    'TEXT TEXT TEXT TEXT ',
            },

            buy_tickets: 'Buy Tickets',

        }
    }
}